import { render, staticRenderFns } from "./yandex.vue?vue&type=template&id=a275725c&scoped=true&"
import script from "./yandex.vue?vue&type=script&lang=js&"
export * from "./yandex.vue?vue&type=script&lang=js&"
import style0 from "./yandex.vue?vue&type=style&index=0&id=a275725c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275725c",
  null
  
)

export default component.exports